export default __webpack_public_path__ + "static/media/Landwey.7cc2df06.png";